export const en = {
  returnRequestDate: {
    label: "Your return request was made on {{date}} at {{time}}",
  },
  actions: {
    continue: "Continue",
  },
  "order-identification": {
    title: "Track your order",
    description: "Enter your order details to track your package",
    fields: {
      "zip-code": {
        title: "Zip code",
        description: "Enter your delivery zip code",
        required: "Zip code is required",
      },
      email: {
        title: "Email address",
        description: "Enter the email address used for your order",
        required: "Email address is required",
      },
      both: {
        title: "Postal code or email",
        description: "Enter your delivery postal code or the email used for your order",
        required: "Postal code or email is required",
      },
      "tracking-number": {
        title: "Order number",
        description: "Enter your order number",
        required: "Order number is required",
      },
    },
    errors: {
      "unknown-order": {
        title: "Unknown order number",
        description: "The order number was not found, please check it",
      },
      "order-not-shipped": {
        title: "Order in preparation",
        description: "Your order has not been shipped yet",
      },
      "search-error": {
        title: "Search error",
        description: "We could not find the order. Please try again later.",
      },
    },
  },
  delivery: "Delivery",
  "parcel-history": "Parcel History",
  "order-details": {
    title: "Order Details",
    "tracking-number": "Tracking Number",
    "order-number": "Order Number",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Estimated Delivery Date",
      deliveredOn: "Delivered on",
      from: "from",
      to: "to",
    },
  },
  deliveryAddress: {
    title: "Delivery address:",
    titlePickup: "Pickup point address:",
    orderDetails: {
      title: "Order details:",
      trackingNumber: "Tracking number:",
      orderNumber: "Order number:",
      orderDate: "Order date:",
    },
  },
  pickupPoint: {
    title: "Pickup Point",
    openingHours: "Opening Hours:",
    closed: "Closed",
    directions: "Directions",
    days: {
      monday: "Monday:",
      tuesday: "Tuesday:",
      wednesday: "Wednesday:",
      thursday: "Thursday:",
      friday: "Friday:",
      saturday: "Saturday:",
      sunday: "Sunday:",
    },
  },
  wallet: {
    warningNotEnabled: "You must enable Wallet in your shop settings",
  },
  crossSell: {
    youMightAlsoLike: "You might also like",
  },
  "rate-order": {
    "order-recap": {
      title: "Your order",
      "tracking-label": "Tracking number:",
      "order-label": "Order number:",
    },
    form: {
      title: "Rate your delivery",
      "rating-label": "Rate your delivery experience",
      "comment-label": "Comment (optional)",
      "comment-placeholder": "Share your experience with us…",
      "submit-cta": "Submit my review",
      "update-cta": "Update my review",
      "rating-required": "Please select a rating.",
    },
    "thank-you": {
      title: "Thanks for your feedback!",
      description:
        "Your review has been saved. It will help us improve the delivery experience.",
    },
    errors: {
      "invalid-token": {
        title: "Invalid or expired link",
        description:
          "This link is no longer valid. Please reopen it from your latest tracking email.",
      },
      submit: {
        title: "Something went wrong",
        description:
          "We couldn't save your review. Please try again later.",
      },
    },
  },
  returnLineItems: {
    refund: "Refund(s)",
    exchange: "Exchange(s)",
    newOrder: "New order",
    discount: "Discount(s)",
  },
  returnStoreAddress: {
    mapButton: "View on map",
  },
  shippingInstructions: {
    colissimo:
      "You can now print your return label and drop off your package at the nearest Colissimo relay point.",
    chronoShop2Shop:
      "You can now print your return label and drop off your package at the nearest Chronopost relay point.",
    ups: "You can now print your return label and drop off your package at the nearest UPS relay point.",
    customerCarrier:
      "You can now send your return package to the carrier of your choice.",
    merchantCarrier:
      "We will send you a return label by email within 1 to 3 business days.",
    returnToStore:
      "You can now print your return label and drop off your package at the nearest store.",
    malca:
      "You can now print your return label and drop off your package at the nearest Malca relay point.",
    tnt: "You can now print your return label and drop off your package at the nearest TNT relay point.",
    bonDeRetour:
      "Your return slip is ready. You can now print it and use it for your return.",
    unknownCarrier:
      "You can now print your return label and ship your package with the carrier indicated on the label.",
  },
  downloadLabel: {
    label: "Download my label",
    bonDeRetour: "Download my return slip",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Your shipping label is ready",
    bonDeRetour: "Your return slip is ready",
  },
} as const;
